// v1.9 P0: Card 原子组件
// 3 variants: default (白底+边框) / bordered (双边框) / elevated (无边框+shadow)
// 4 padding: none / sm / md / lg
// as prop 允许渲染为 section/div/article 等
import { type ElementType, type HTMLAttributes, type ReactNode, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

export type CardVariant = 'default' | 'bordered' | 'elevated';
export type CardPadding = 'none' | 'sm' | 'md' | 'lg';

export interface CardProps extends HTMLAttributes<HTMLElement> {
  variant?: CardVariant;
  padding?: CardPadding;
  /** 渲染元素 (默认 div) */
  as?: ElementType;
  children?: ReactNode;
}

const VARIANT_CLASS: Record<CardVariant, string> = {
  default: 'bg-surface border border-line',
  bordered: 'bg-surface border-2 border-line',
  elevated: 'bg-surface shadow-sm',
};

const PADDING_CLASS: Record<CardPadding, string> = {
  none: '',
  sm: 'p-3 sm:p-3',
  md: 'p-4 sm:p-5',
  lg: 'p-5 sm:p-6',
};

export const Card = forwardRef<HTMLElement, CardProps>(function Card(
  { variant = 'default', padding = 'md', as, className, children, ...rest },
  ref,
) {
  const Tag = (as ?? 'div') as ElementType;
  return (
    <Tag
      ref={ref}
      className={twMerge('rounded-lg', VARIANT_CLASS[variant], PADDING_CLASS[padding], className)}
      {...rest}
    >
      {children}
    </Tag>
  );
});
